export const isToggleOptionSelected = <T>(
  selectedValue: T,
  optionValue: T,
): boolean => selectedValue === optionValue;
